import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
import { useMemo } from 'react';
import { ClubShape } from '../../assets/cards/suits/clubShape';
import { DiamondShape } from '../../assets/cards/suits/diamondShape';
import { HeartShape } from '../../assets/cards/suits/heartShape';
import { SpadeShape } from '../../assets/cards/suits/spadeShape';
import { CHAT_PANEL_CARD_BACKGROUND_COLOR } from '../../styles/colors';
import { cardStringParser } from '../../types/cardTypes';
const CONTAINER_CSS = css `
  display: inline-block;
`;
const TYPOGRAPHY_CSS = css `
  margin-right: 0.2em;
`;
const BASE_SUIT_EM_SIZE = 0.8;
const ALL_SIZE_PROPERTIES = {
    regular: {
        rankEmSize: 1,
        suitEmMultiplier: 1
    },
    large: {
        rankEmSize: 2,
        suitEmMultiplier: 2
    }
};
function renderCardShape(suit, size, isFourColorDeck, overrideColor) {
    const emSize = ALL_SIZE_PROPERTIES[size].suitEmMultiplier * BASE_SUIT_EM_SIZE;
    switch (suit) {
        case 'club': {
            return _jsx(ClubShape, { emSize: emSize, isFourColorDeck: isFourColorDeck, overrideColor: overrideColor });
        }
        case 'diamond': {
            return _jsx(DiamondShape, { emSize: emSize, isFourColorDeck: isFourColorDeck, overrideColor: overrideColor });
        }
        case 'heart': {
            return _jsx(HeartShape, { emSize: emSize, overrideColor: overrideColor });
        }
        case 'spade': {
            return _jsx(SpadeShape, { emSize: emSize, overrideColor: overrideColor });
        }
    }
}
export const TextAreaCardDisplay = ({ card: cardOrShorthand, size = 'regular', isFourColorDeck, overrideColor, overrideBackgroundColor }) => {
    const contentsCss = useMemo(() => css `
      padding: 0 1px 0 3px;
      margin: 1px;
      background-color: ${overrideBackgroundColor || CHAT_PANEL_CARD_BACKGROUND_COLOR};
      color: ${overrideColor || 'black'};
      display: flex;
      flex-direction: row;
      align-items: center;
      border-radius: 15%;
    `, [overrideBackgroundColor, overrideColor]);
    const rankCss = useMemo(() => css `
      font-size: ${ALL_SIZE_PROPERTIES[size].rankEmSize}em;
      font-weight: 900;
      letter-spacing: -0.05em;
    `, [size]);
    if (!cardOrShorthand) {
        return null;
    }
    const card = typeof cardOrShorthand === 'string' ? cardStringParser(cardOrShorthand) : cardOrShorthand;
    return (_jsx("div", { css: CONTAINER_CSS, children: _jsxs("div", { "aria-label": `${card.rankCardLabel} of ${card.suit}s`, "aria-hidden": true, css: contentsCss, children: [_jsx(Typography, { css: TYPOGRAPHY_CSS, sx: { fontSize: 'inherit' }, children: _jsx("span", { css: rankCss, children: card.rankCardLabel }) }), renderCardShape(card.suit, size, isFourColorDeck, overrideColor)] }) }));
};
